<template>
  <section id="section-event" class="notice-section">
    <header class="notice-section__top">
      <div class="notice-section__heading">
        <h2>{{ $t('notice.eventTitle') }}</h2>
      </div>
      <form class="notice-search" @submit.prevent="applySearch">
        <label class="notice-search__field">
          <span class="sr-only">{{ $t('games.searchPlaceholder') }}</span>
          <input
            v-model.trim="searchInput"
            type="search"
            :placeholder="$t('games.searchPlaceholder')"
            autocomplete="off"
          >
          <svg class="notice-search__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2" />
            <path d="M16 16l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </label>
        <button type="submit" class="notice-search__btn">{{ $t('betting.search') }}</button>
      </form>
    </header>

    <div class="notice-panel">
      <p v-if="loading" class="notice-section__status">{{ $t('notice.loadingEvent') }}</p>
      <p v-else-if="loadError" class="notice-section__status notice-section__status--error">{{ loadError }}</p>
      <p v-else-if="!filteredEvents.length" class="notice-section__status">{{ $t('notice.emptyEvent') }}</p>

      <div v-else class="notice-table-wrap">
        <table class="notice-table">
          <thead>
            <tr>
              <th scope="col" class="notice-table__col-no">{{ $t('notice.colNo') }}</th>
              <th scope="col" class="notice-table__col-cat">{{ $t('notice.colCategory') }}</th>
              <th scope="col" class="notice-table__col-title">{{ $t('notice.colTitle') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in filteredEvents"
              :key="item.idx"
              class="notice-table__row"
            >
              <td class="notice-table__col-no">
                <span
                  class="notice-table__no"
                  :class="{ 'notice-table__no--important': isImportant(item) }"
                >{{ rowLabel(item, index) }}</span>
              </td>
              <td class="notice-table__col-cat">{{ $t('notice.categoryEvent') }}</td>
              <td class="notice-table__col-title">
                <button
                  type="button"
                  class="notice-table__title"
                  @click="openDetail(item.idx)"
                >
                  {{ item.title }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { SystemService } from '@/services'

const EVENT_TYPE = 4

export default {
  name: 'BlackGoldEventPage',
  data () {
    return {
      loading: false,
      loadError: '',
      events: [],
      total: 0,
      searchInput: '',
      searchQuery: ''
    }
  },
  computed: {
    filteredEvents () {
      if (!this.searchQuery) return this.events
      const q = this.searchQuery.toLowerCase()
      return this.events.filter(item => String(item.title || '').toLowerCase().indexOf(q) !== -1)
    }
  },
  mounted () {
    this.loadEvents()
  },
  methods: {
    reload () {
      this.loadEvents()
    },
    applySearch () {
      this.searchQuery = this.searchInput
    },
    rowLabel (item, index) {
      if (Number(item.is_child) >= 2) return this.$t('notice.priority')
      return String(this.filteredEvents.length - index)
    },
    isImportant (item) {
      return Number(item.is_child) >= 2
    },
    openDetail (idx) {
      this.$emit('open-detail', idx)
    },
    async loadEvents () {
      this.loading = true
      this.loadError = ''
      try {
        const res = await SystemService.getNoticeList(0, 100, EVENT_TYPE)
        if (res.data && res.data.code === 0 && res.data.data) {
          this.events = Array.isArray(res.data.data.list) ? res.data.data.list : []
          this.total = Number(res.data.data.total) || this.events.length
        } else {
          this.events = []
          this.total = 0
          this.loadError = this.$t('notice.errorEvent')
        }
      } catch (err) {
        this.events = []
        this.total = 0
        this.loadError = this.$t('notice.errorEvent')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
